export const GET_MAP_DETAILS = "GET_MAP_DETAILS";
export const RESET_MAP_DETAILS = "RESET_MAP_DETAILS";
export const GET_MAP_COUNTS = "GET_MAP_COUNTS";
export const RESET_MAP_COUNTS = "RESET_MAP_COUNTS";
